/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 14.05.13, 11:44
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { RuntimeLoadedFontConfigVO } from "./RuntimeLoadedFontConfigVO";

export class ArialUnicodeMSFontConfigVO extends RuntimeLoadedFontConfigVO {
    /**
     * Defines common offset values for the Arial Unicode MS Font
     * @param ggsLanguageCode
     */
    constructor(ggsLanguageCode: string) {
        super(ggsLanguageCode);

        // Arial Unicode should have a slightly smaller font size
        this.fontScale = 0.9;


        // Font sizes below 12 may be too small
        this.fontSizeMinimum = 9;

        // Adjust y position
        this.yOffset = -1;
    }
}
